<template>
  <div class="financial-trend-wrap">
    <div class="section-label">Trends</div>
    <div class="chart-grid">
      <ChartCard v-for="chart in yearCharts" :key="chart.title" v-bind="chart" />
    </div>
    <div class="analytics-grid">
      <ChartCard v-for="chart in halfYearCharts" :key="chart.title" v-bind="chart" />
    </div>
  </div>
</template>

<script>
import ChartCard from "./ChartCard.vue";
import { areaChartOptions, columnChartOptions } from "../dashboardCharts";

const valueTrendChart = ({ title, subtitle, pillTone, trend, type, color }) => ({
  title,
  subtitle,
  pill: "6 months",
  pillTone,
  type,
  height: "280",
  series: [{ name: title, data: trend.values || [] }],
  options:
    type === "area"
      ? areaChartOptions({ categories: trend.months, color })
      : columnChartOptions({ categories: trend.months, colors: [color], columnWidth: "48%" }),
  hasData: trend.months.length > 0,
  emptyText: "No data yet.",
});

// Year-long business/profit/expense and net asset, plus 6-month credit and stock trends.
export default {
  name: "FinancialTrendsSection",
  components: { ChartCard },
  props: {
    financialTrend: { type: Object, required: true },
    creditPayableTrend: { type: Object, required: true },
    creditReceivableTrend: { type: Object, required: true },
    stockValueTrend: { type: Object, required: true },
  },
  computed: {
    yearCharts() {
      const trend = this.financialTrend;
      const common = { pill: "12 months", height: "320", hasData: trend.months.length > 0, emptyText: "No trend data yet." };
      return [
        {
          ...common,
          title: "Business, Profit & Expense",
          subtitle: "Monthly movement across the year.",
          icon: "bar-chart-2",
          type: "bar",
          series: [
            { name: "Business", data: trend.business || [] },
            { name: "Profit", data: trend.profit || [] },
            { name: "Expense", data: trend.expense || [] },
          ],
          options: columnChartOptions({
            categories: trend.months,
            colors: ["#f6a044", "#22c55e", "#ef4444"],
            columnWidth: "58%",
            yearLong: true,
            legend: true,
          }),
        },
        {
          ...common,
          title: "Net Asset",
          subtitle: "Overall asset growth.",
          icon: "trending-up",
          type: "area",
          series: [{ name: "Net Asset", data: trend.net_asset || [] }],
          options: areaChartOptions({ categories: trend.months, color: "#8b5cf6", yearLong: true }),
        },
      ];
    },
    halfYearCharts() {
      return [
        valueTrendChart({
          title: "Credit Payable",
          subtitle: "Owed to distributors.",
          pillTone: "tone-red-pill",
          trend: this.creditPayableTrend,
          type: "bar",
          color: "#ef4444",
        }),
        valueTrendChart({
          title: "Credit Receivable",
          subtitle: "Due from customers.",
          pillTone: "tone-purple-pill",
          trend: this.creditReceivableTrend,
          type: "bar",
          color: "#8b5cf6",
        }),
        valueTrendChart({
          title: "Stock Value",
          subtitle: "Inventory on hand.",
          pillTone: "tone-teal-pill",
          trend: this.stockValueTrend,
          type: "area",
          color: "#14b8a6",
        }),
      ];
    },
  },
};
</script>
